import * as React from "react";
import styled from "styled-components";

const StyledInput = styled.input`
  height: 36px;
  width: 100%;
  min-width: 0;
  border-radius: 6px;
  border: 1px solid var(--color-grey-100);
  padding: 4px 12px;
  font-size: 16px;
  color: var(--color-coal);
  background-color: var(--color-white);
  outline: none;
  transition: color 0.15s, box-shadow 0.15s, border-color 0.15s;
  &::file-selector-button {
    height: 28px;
    border: 0;
    background: transparent;
    font-size: 14px;
    font-weight: var(--font-weight-medium);
  }
  &:focus-visible {
    border-color: var(--color-petrol);
    box-shadow: 0 0 0 3px var(--color-petrol-25);
  }
  &[aria-invalid="true"] {
    border-color: var(--color-alert-color);
  }
  &:disabled {
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

function Input({ className, type, ...props }: React.InputHTMLAttributes<HTMLInputElement>) {
  return (
    <StyledInput
      type={type}
      data-slot="input"
      className={className}
      {...props}
    />
  );
}

export { Input };
